import axios from 'axios';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  addCompanyPayrollRequest,
  getCompanyPayrollRequest,
  updateCompanyPayrollRequest,
} from 'api/requests/company-requests';
import {
  COMPANY__ADD_PAYROLL,
  COMPANY__ADD_PAYROLL_ERROR,
  COMPANY__ADD_PAYROLL_SUCCESS,
  COMPANY__CLEAR_PAYROLL,
  COMPANY__GET_PAYROLL,
  COMPANY__SET_PAYROLL,
  COMPANY__SET_PAYROLL_ERROR,
  COMPANY__SET_PAYROLL_ERROR_MESSAGE,
  COMPANY__UPDATE_PAYROLL,
  COMPANY__UPDATE_PAYROLL_ERROR,
  COMPANY__UPDATE_PAYROLL_SUCCESS,
  PAYROLL__GENERAL_LOADING,
} from 'store/constants';
import { GENERAL__ERROR_MESSAGE } from 'translations/constants';
import ICompanyPayrollGeneral from 'types/company/payroll/ICompanyPayrollGeneral';

const extractErrorKey = (error: unknown): string =>
  axios.isAxiosError(error) && error.response && error.response.status === 400 && error.response.data
    ? error.response.data
    : GENERAL__ERROR_MESSAGE;

export const setPayrollRequestsLoadingAction = createAction<boolean>(PAYROLL__GENERAL_LOADING);

export const setPayrollAction = createAction<ICompanyPayrollGeneral>(COMPANY__SET_PAYROLL);
export const getPayrollErrorAction = createAction<boolean>(COMPANY__SET_PAYROLL_ERROR);

export const getPayrollAction = createAsyncThunk(COMPANY__GET_PAYROLL, async (companyId: number, thunkApi) => {
  thunkApi.dispatch(getPayrollErrorAction(false));
  thunkApi.dispatch(setPayrollRequestsLoadingAction(true));
  try {
    const response = await getCompanyPayrollRequest(companyId);
    thunkApi.dispatch(setPayrollAction(response));
  } catch (error) {
    thunkApi.dispatch(getPayrollErrorAction(true));
  }
  thunkApi.dispatch(setPayrollRequestsLoadingAction(false));
});

export const addPayrollSuccessAction = createAction<boolean>(COMPANY__ADD_PAYROLL_SUCCESS);
export const addPayrollErrorAction = createAction<string>(COMPANY__ADD_PAYROLL_ERROR);
export const setPayrollErrorMessageAction = createAction<string | null>(COMPANY__SET_PAYROLL_ERROR_MESSAGE);

export const addPayrollAction = createAsyncThunk(
  COMPANY__ADD_PAYROLL,
  async (payroll: ICompanyPayrollGeneral, thunkApi) => {
    thunkApi.dispatch(setPayrollRequestsLoadingAction(true));
    thunkApi.dispatch(addPayrollErrorAction(''));
    thunkApi.dispatch(addPayrollSuccessAction(false));
    thunkApi.dispatch(setPayrollErrorMessageAction(null));
    try {
      await addCompanyPayrollRequest(payroll);
      thunkApi.dispatch(addPayrollSuccessAction(true));
    } catch (error) {
      thunkApi.dispatch(addPayrollErrorAction(extractErrorKey(error)));
      thunkApi.dispatch(setPayrollErrorMessageAction(axios.isAxiosError(error) ? error.response?.data ?? null : null));
    }
    thunkApi.dispatch(setPayrollRequestsLoadingAction(false));
  },
);

export const updatePayrollSuccessAction = createAction<boolean>(COMPANY__UPDATE_PAYROLL_SUCCESS);
export const updatePayrollErrorAction = createAction<string>(COMPANY__UPDATE_PAYROLL_ERROR);

export const updatePayrollAction = createAsyncThunk(
  COMPANY__UPDATE_PAYROLL,
  async (payroll: ICompanyPayrollGeneral, thunkApi) => {
    thunkApi.dispatch(setPayrollRequestsLoadingAction(true));
    thunkApi.dispatch(updatePayrollErrorAction(''));
    thunkApi.dispatch(updatePayrollSuccessAction(false));
    thunkApi.dispatch(setPayrollErrorMessageAction(null));
    try {
      await updateCompanyPayrollRequest(payroll);
      thunkApi.dispatch(updatePayrollSuccessAction(true));
    } catch (error) {
      thunkApi.dispatch(updatePayrollErrorAction(extractErrorKey(error)));
      thunkApi.dispatch(setPayrollErrorMessageAction(axios.isAxiosError(error) ? error.response?.data ?? null : null));
    }
    thunkApi.dispatch(setPayrollRequestsLoadingAction(false));
  },
);

export const clearCompanyPayrollAction = createAction<void>(COMPANY__CLEAR_PAYROLL);
